import { Helmet } from 'react-helmet-async';

const SITE = 'https://www.ledomainedupilat.fr';
const DEFAULT_IMAGE = 'https://res.cloudinary.com/amenitiz/image/upload/q_auto,f_auto,w_1200/v1695021840/jxscs29isbyunx4jx3e2.jpg';

export default function Seo({ title, description, path = '/', image = DEFAULT_IMAGE }) {
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="Le Domaine du Pilat" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
